import OrderDetails from "../OrderDetails";
import SetOrderAsDelivered from "./SetOrderAsDelivered";
import { OrderStatus } from "utils/server-constants/orderStatuses";

const MoreOrderDetails = (props) => (
	<OrderDetails
		{...props}
		renderAction={(onClose) =>
			props.status === OrderStatus.ASSIGNED && (
				<SetOrderAsDelivered orderId={props.order_number} onSuccess={onClose} />
			)
		}
	/>
);
export default MoreOrderDetails;
